import React, { useState, useCallback } from 'react'
import ReactDOM from 'react-dom'
import { useUnmount } from 'react-use'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { withRouter } from 'react-router-dom'
import { getVehicleEventsPath } from 'lib/utils/store/vehicle'
import { getPrimaryLocation } from 'lib/location'
import { getLocale } from 'lib/utils/getLocale'

import ControlledModal from 'components/Modal/ControlledModal'
import TimelineFilters, { defaultFilters, filtersToObject, filtersToString } from 'components/Timeline/TimelineFilters/TimelineFilters'
import Button from 'components/UI/Button'

import './timeline-filters-modal.pcss'

const TimelineFiltersModal = ({ history, location, match }) => {
    const [filters, setFilters] = useState({
        ...defaultFilters,
        ...filtersToObject(getPrimaryLocation(location).search)
    })

    const { t, i18n } = useTranslation(['events'])

    useUnmount(() => {
        // apply filters to url when closing modal
        history.replace({
            pathname: `${getLocale(i18n.language)}${getVehicleEventsPath(match.params.vehicleId)}`,
            search: filtersToString(filters),
        })
    })

    const handleChange = useCallback((filters) => {
        setFilters(filters)
    }, [setFilters])

    const renderActions = useCallback((closeModal) => {
        return (
            <Button
                onClick={closeModal}
                className="button"
                trackName="done"
            >
                {t('common:done')}
            </Button>
        )
    }, [t])

    return (
        <ControlledModal
            routedModal
            name="timeline-filters-modal"
            context="timelineFiltersModal"
            initialTitle={null}
            requireUserInput={false}
        >
            {({ closeModal, mobileButtonsDOMElement }) => (
                <div className="timeline-filters-modal">
                    <div className="timeline-filters-modal__filters">
                        <TimelineFilters
                            filters={filters}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="timeline-filters-modal__actions">
                        {mobileButtonsDOMElement && (
                            ReactDOM.createPortal(
                                renderActions(closeModal),
                                mobileButtonsDOMElement
                            )
                        )}
                        <div className="timeline-filters-modal__actions">
                            {renderActions(closeModal)}
                        </div>
                    </div>
                </div>
            )}
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
)(TimelineFiltersModal)
